import { createSelector } from 'utils/app.util';

export const getProjectNonProductiveTimeFromState = createSelector(
  (state) => state.getIn(['projects', 'npt', 'data']),
  (npts) => npts,
);
